module.exports = __webpack_public_path__ + "static/media/uploadButton.c0bbb7e1.svg";